import { useNavigate } from "react-router-dom";

import { Models } from "api/types";
import ProductCarousel from "organisms/product-carousel/ProductCarousel";

const RetailProductsCTA = ({
  retailProducts,
}: {
  retailProducts: Models<"ListingModel">[];
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/shop/products");
  };
  const carouselCards = retailProducts.map((product) => {
    const card = {
      to: `/pdp/product/${product.id}`,
      imageSrc: product.imageUrl || "",
      title: product.title,
      tag: "Product" as string,
      price: product.baseCost,
      memberPrice: product.baseCost,
    };

    return card;
  });

  return (
    <div className="relative box-border w-full cursor-pointer overflow-hidden bg-cover bg-center">
      <ProductCarousel
        title="TOP SELLING PRODUCTS"
        cards={carouselCards}
        primary="View All Products"
        onButtonClick={handleClick}
      />
    </div>
  );
};

export default RetailProductsCTA;
